import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/* Material Symbols paths are long single strings; keep intact for fidelity. */
/* eslint-disable max-len */

const PACKAGE_2_OUTLINED_PATH =
    'M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z';

const PACKAGE_2_FILLED_PATH =
    'M440-91v-366L120-642v321q0 22 10.5 40t29.5 29L440-91Zm80 0 280-161q19-11 29.5-29t10.5-40v-321L520-457v366Zm159-550 118-69-277-159q-19-11-40-11t-40 11l-79 45 318 183ZM480-526l119-68-317-184-120 69 318 183Z';

/* eslint-enable max-len */

/** Material Symbols `package_2` outlined (FILL=0) */
export const Package2OutlinedIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 -960 960 960">
        <path d={PACKAGE_2_OUTLINED_PATH} />
    </SvgIcon>
);

/** Material Symbols `package_2` filled (FILL=1) */
export const Package2Icon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 -960 960 960">
        <path d={PACKAGE_2_FILLED_PATH} />
    </SvgIcon>
);
